import React from 'react'
import {
  FieldArray as FinalFieldArray,
  FieldArrayRenderProps,
} from 'react-final-form-arrays'

import { useFieldContext } from '../Field'

export { default as useFieldArray } from './useFieldArray'

type TFieldArray = {
  children?:
    | React.ReactNode
    | ((props: FieldArrayRenderProps<unknown, any>) => React.ReactNode)
  name?: string
  field?: string
}
const FieldArray = (props: TFieldArray): React.ReactElement => {
  const { children } = props

  const { prefix } = useFieldContext()

  let name = props.name || props.field
  if (prefix) {
    name = `${prefix}.${name}`
  }
  return <FinalFieldArray name={name as string}>{children}</FinalFieldArray>
}

export default FieldArray
